<div class="auth-action-container">
  <app-loading [hidden]="!(viewModel.isLoading$ | async)" [options]="(viewModel.loadingOpts$ | async) ?? undefined" />
  <div class="auth-flow-wrapper">
    <div class="auth-flow-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<div class="auth-brand-container">
  <div class="brand-wrapper">
    <div class="img-container">
      <img [src]="splashImage$ | async" alt="fallback-image" i18n-alt />
    </div>
  </div>
</div>
